export const FETCH_NAVLOGS = "FETCH_NAVLOGS";
export const FETCH_NAVLOGS_SUCCESS = "FETCH_NAVLOGS_SUCCESS";
export const SAVE_NAVLOG = "SAVE_NAVLOG";
export const SAVE_NAVLOG_SUCCESS = "SAVE_NAVLOG_SUCCESS";
